import { userApi } from "@/user/api";

export const ws = {
    summary: () => userApi.get("/workspace/summary").then((r) => r.data),
    listSubmissions: (params = {}) =>
        userApi.get("/workspace/submissions", { params }).then((r) => r.data),
    getSubmission: (id) => userApi.get(`/workspace/submissions/${id}`).then((r) => r.data),
    createSubmission: (body) => userApi.post("/workspace/submissions", body).then((r) => r.data),
    updateSubmission: (id, body) => userApi.patch(`/workspace/submissions/${id}`, body).then((r) => r.data),
    submitSubmission: (id) => userApi.post(`/workspace/submissions/${id}/submit`).then((r) => r.data),
    deleteSubmission: (id) => userApi.delete(`/workspace/submissions/${id}`).then((r) => r.data),
    uploadAttachment: (body) => userApi.post("/workspace/attachments", body).then((r) => r.data),
    getAttachment: (id) => userApi.get(`/workspace/attachments/${id}`).then((r) => r.data),
    deleteAttachment: (id) => userApi.delete(`/workspace/attachments/${id}`).then((r) => r.data),
    listDocuments: () => userApi.get("/workspace/documents").then((r) => r.data),
    listTasks: (params = {}) => userApi.get("/workspace/tasks", { params }).then((r) => r.data),
    createTask: (body) => userApi.post("/workspace/tasks", body).then((r) => r.data),
    updateTask: (id, body) => userApi.patch(`/workspace/tasks/${id}`, body).then((r) => r.data),
    deleteTask: (id) => userApi.delete(`/workspace/tasks/${id}`).then((r) => r.data),
};

export function readFileAsBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
}

export function fmtBytes(n) {
    if (!n) return "0 B";
    const u = ["B", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(n) / Math.log(1024));
    return `${(n / Math.pow(1024, i)).toFixed(i ? 1 : 0)} ${u[i]}`;
}

export function fmtDate(iso) {
    if (!iso) return "—";
    try {
        return new Date(iso).toLocaleString(undefined, {
            month: "short", day: "numeric", hour: "2-digit", minute: "2-digit",
        });
    } catch {
        return iso;
    }
}

export function downloadAttachment(att) {
    const parts = (att.data_base64 || "").split(",");
    const b64 = parts[parts.length - 1];
    const byteChars = atob(b64);
    const bytes = new Uint8Array(byteChars.length);
    for (let i = 0; i < byteChars.length; i++) bytes[i] = byteChars.charCodeAt(i);
    const blob = new Blob([bytes], { type: att.content_type || "application/octet-stream" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = att.filename || "download";
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
}
